// Mock data for LightSpeed ROI — content sourced from lightspeedroihq.lovable.app
// All data is FRONTEND MOCK only.

// Build a trade-page slug from a trade name, e.g. "Pest Control" -> "pest-control-houston-tx"
export const toSlug = (name) =>
  name
    .toLowerCase()
    .replace(/&/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "") + "-houston-tx";

export const IMAGES = {
  logo:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_design-merge-preview/artifacts/68ht7sop_IMG_5900.png",
  heroContractor: "/brand/legacy.png",
  missedCall: "https://customer-assets-wrfwihn1.emergentagent.net/job_design-merge-preview/artifacts/ho5zmdx6_IMG_6480.jpeg",
  crew: "/brand/family.png",
  deliver: "/brand/solo.png",
  founder:
    "https://customer-assets-eiarnc6j.emergentagent.net/job_d08eb082-f146-4572-80d0-9a04db93bac1/artifacts/z406k3lx_IMG_0804.jpeg",
};

export const NAV_LINKS = [
  { label: "The System", href: "#stack" },
  { label: "How it works", href: "#how" },
  { label: "Trades", href: "#trades" },
  { label: "Reactivation", href: "/database-reactivation" },
  { label: "Blog", href: "/blog" },
  { label: "Free Audit", href: "#audit" },
];

export const HERO = {
  eyebrow: "Built for home service pros",
  titleLines: ["Stop Losing Jobs", "To The Guy Who"],
  titleHighlight: "Answers First.",
  subtitle:
    "Most contractors don't lose jobs because of their price or their work. They lose them because they miss the call or follow up too late.",
  note: "Website built free. $597/mo. Cancel anytime.",
  value: "One extra job usually pays for it.",
  quote: "The job doesn't go to the best contractor. It goes to the first one who picks up.",
  quoteAuthor: "Dyan Holden",
};

export const PAIN_POINTS = [
  { n: "01", text: "I miss calls while I'm on jobs." },
  { n: "02", text: "People don't trust my business online." },
  { n: "03", text: "I forget to follow up." },
  { n: "04", text: "I don't ask for reviews." },
  { n: "05", text: "My website feels like it was built in 2008." },
  { n: "06", text: "I lose thousands because I can't answer the phone." },
];

export const STACK = [
  {
    n: "01",
    title: "Your Website",
    solves: "You feel outdated & lose trust",
    body: "A fast, mobile-first site built to get people to call you — or we can improve the one you already have.",
    icon: "Globe",
  },
  {
    n: "02",
    title: "Phone Gets Answered",
    solves: "You can't answer the phone",
    body: "When you're busy or it's after hours, your phone still gets answered and it tries to book the job.",
    icon: "PhoneCall",
  },
  {
    n: "03",
    title: "Missed-Call Text Back",
    solves: "Missed call = lost job",
    body: "Texts them back in 3 seconds so they don't call the next guy.",
    icon: "MessageSquare",
  },
  {
    n: "04",
    title: "Google Reviews",
    solves: "You never ask for reviews",
    body: "Helps turn every happy customer into a 5-star Google review — without you having to ask.",
    icon: "Star",
  },
  {
    n: "05",
    title: "Every Lead In One Place",
    solves: "Leads sit in your inbox and die",
    body: "All your calls, texts, and leads in one simple spot. Nothing slips through the cracks.",
    icon: "Users",
  },
  {
    n: "06",
    title: "Online Booking",
    solves: "Double-booking. Confusion.",
    body: "Customers pick a time. It shows up on your phone. Done.",
    icon: "CalendarDays",
  },
  {
    n: "07",
    title: "Automatic Follow-Up",
    solves: "You forget to follow up",
    body: "Every quote and lead gets followed up automatically so nothing dies.",
    icon: "Workflow",
  },
];

export const SHORT_QUOTES = [
  "This system booked me 14 jobs last month.",
  "I stopped missing leads. Straight up.",
  "My phone rings. My calendar fills. That's it.",
];

export const STEPS = [
  {
    n: "01",
    title: "We build (or improve) your website",
    body: "For free. Zero setup fee. Real photos, real copy, done for you.",
  },
  {
    n: "02",
    title: "We set up instant text on missed calls",
    body: "Miss a call and they get a text from you in 3 seconds — before they call the next guy.",
  },
  {
    n: "03",
    title: "We set up phone answering & follow-up",
    body: "Your phone gets answered when you're busy, and every lead and quote gets followed up automatically.",
  },
  {
    n: "04",
    title: "You start booking more jobs",
    body: "Your phone rings. Your calendar fills. You show up and do the work.",
  },
];

export const PRICING_FEATURES = [
  "A clean website built to get people to call you (or we improve the one you have)",
  "Instant text when you miss a call",
  "Phone gets answered when you're busy and tries to book the job",
  "Automatic follow-up so leads and quotes don't die",
  "Help turning happy customers into Google reviews",
  "Call tracking so you can see what's working",
  "Local setup so people in your area find you",
  "Everything stays simple so nothing falls through the cracks",
  "You own your site, domain & data",
  "No setup fee — cancel anytime",
];

export const PRICING_NOTE =
  "You don't have to take everything. If you already have a website or other tools, we can work with what you have.";

export const GUARANTEE = {
  title: "Results or we work free",
  body: "If you don't book more jobs in your first 60 days, we keep working for free until you do. You own your website, domain, and data from day one — no hostage situation, ever.",
};

export const SCARCITY = "Currently onboarding just 3 new companies this month.";

export const RESULTS = [
  {
    name: "Marcus D.",
    company: "Bayou City Air & Heat",
    trade: "HVAC",
    outcome: "Booked 14 extra jobs in 60 days",
    quote: "The text-back alone paid for the whole thing in week one. My calendar hasn't been this full in years.",
  },
  {
    name: "Ray T.",
    company: "TidalFlow Plumbing",
    trade: "Plumbing",
    outcome: "Grabbed a 2am slab leak — $6,800 job",
    quote: "A call I would've slept through got booked before I woke up. That never happened before.",
  },
  {
    name: "Sandra P.",
    company: "Lone Star Roofing Co.",
    trade: "Roofing",
    outcome: "11 new Google reviews in 2 weeks",
    quote: "Homeowners tell me they called because of the reviews. I never had to ask for a single one.",
  },
];

export const COMPARISON = {
  agency: {
    title: "The big agency",
    items: [
      "Sold by one person. Handed to an account manager you never met.",
      "Reports show impressions and clicks. Never booked jobs.",
      "You're one of dozens in a queue. You wait.",
      "Changes go through a ticket system. Weeks, not days.",
      "They hold your site, your domain, and your data hostage.",
    ],
  },
  me: {
    title: "Working with me",
    items: [
      "The person who sells you is the person doing the work. That's me.",
      "Small roster. Real attention. Nobody's competing with you inside my book.",
      "You text me. I make the change. Usually same day.",
      "You own everything we build. Website, domain, data. From day one.",
      "I report on calls and booked jobs. The numbers that pay you.",
    ],
  },
};

export const MESSAGES = [
  {
    trade: "HVAC — Kemah",
    quote: "6 leads came in yesterday. I booked 4 already and the calendar looks packed.",
  },
  {
    trade: "Roofing — League City",
    quote: "A homeowner said she called because of the reviews — 11 came in over two weeks.",
  },
  {
    trade: "Plumbing — Friendswood",
    quote: "A slab leak came in at 2am and the text-back grabbed it. Booked before I was even awake.",
  },
  {
    trade: "Electrical — Clear Lake",
    quote: "Just closed a $9,400 panel and generator job — the first one that ever booked from my site.",
  },
  {
    trade: "Landscaping — Webster",
    quote: "3 new maintenance routes this week. That's about $14k a year from those alone.",
  },
  {
    trade: "Pest Control — Pasadena",
    quote: "Booked out through next week. Had to turn work away — that's never happened before.",
  },
];

export const BIO = {
  name: "Dyan Holden",
  role: "Founder",
  eyebrow: "Who you actually work with",
  heading: "One accountable person. That's it.",
  paragraphs: [
    "I'm Dyan. Before this, I spent 10 years in the television industry down in South Florida, producing shows and running crews. Different world, same lesson: the promise is easy. The delivery is the whole game.",
    "Then I sold insurance. That taught me exactly what a homeowner sounds like when they've been oversold and underdelivered — polite on the phone, done in their head. I sat across from a lot of those people. It bothered me.",
    "Then I watched contractors — good guys, real skill, hard workers — get chewed up by agencies. Sold a website. Handed a report. Nothing changes on the calendar. Same overpromise, same underdeliver. I'd lived on both sides of that hustle. I got sick of watching it.",
    "So I built this. Home services only. One person doing the actual work. Website built for free. A stack that answers the phone, texts them back, follows up, and asks for the review. You talk to me. I do the work. The results show up as booked jobs. That's the whole pitch.",
    "I'm the reformed version of the exact thing that used to let you down. That's the only reason this works.",
  ],
};

export const DBR = {
  eyebrow: "Free money already in your phone",
  heading: "Bring Back Old Customers",
  headline: "Your old customer list is sitting on booked jobs.",
  body:
    "Every home service business has a pile of past customers and dead leads — people who already know you and trust you. We text that list for you, start real conversations, and book the ready ones straight onto your calendar. No ad spend. No cold leads. Just work you already earned.",
  steps: [
    {
      n: "01",
      title: "We load your list",
      body: "Old customers, dead leads, past estimates — we bring your existing contacts into the system.",
    },
    {
      n: "02",
      title: "We text them for you",
      body: "A friendly text goes out to your whole list, replies get handled, and interested folks get lined up — automatically, day and night.",
    },
    {
      n: "03",
      title: "Jobs hit your calendar",
      body: "Ready customers get booked automatically. You just show up and do the work.",
    },
  ],
  stats: [
    { value: "0", label: "Ad spend required" },
    { value: "24/7", label: "Follow-up that never sleeps" },
    { value: "1", label: "Sleepy list, reactivated" },
  ],
};

export const TRADES = [
  { name: "HVAC", icon: "Snowflake" },
  { name: "Plumbing", icon: "Wrench" },
  { name: "Roofing", icon: "Home" },
  { name: "Electrical", icon: "Zap" },
  { name: "Painting", icon: "Paintbrush" },
  { name: "Flooring", icon: "Layers" },
  { name: "Landscaping", icon: "Sprout" },
  { name: "Cleaning", icon: "SprayCan" },
  { name: "Moving", icon: "Package" },
  { name: "Pest Control", icon: "Bug" },
  { name: "Solar", icon: "Sun" },
  { name: "Tree Service", icon: "TreePine" },
  { name: "Pressure Washing", icon: "Droplets" },
  { name: "Handyman", icon: "Hammer" },
  { name: "Remodeling", icon: "PencilRuler" },
  { name: "Fence", icon: "Fence" },
  { name: "Exterior Services", icon: "Building2" },
];

export const SERVICE_AREA =
  "We work with home service pros wherever you are. Local setup so the right people find you.";

export const ADDONS_NOTE =
  "You don't have to get any of these. They're optional. Most guys start with the main system first.";

export const ADDONS = [
  {
    title: "Old Customer Reactivation",
    price: "$197/month",
    body: "We reach out to your old customers who haven't called in a while and try to bring them back.",
    icon: "Users",
  },
  {
    title: "Maintenance Plan System",
    price: "$197/month",
    body: "Helps you sell service agreements so you get recurring monthly income.",
    icon: "CalendarCheck",
  },
  {
    title: "Google Boost",
    price: "$297/month",
    body: "Helps your business show up better when people in your area search on Google.",
    icon: "Search",
  },
  {
    title: "Seasonal Campaigns",
    price: "$147/month",
    body: "Automatic messages that go out during busy seasons (like AC tune-up time).",
    icon: "Sun",
  },
  {
    title: "Extra Call Tracking",
    price: "$97/month",
    body: "Gives you clearer reports so you can see which calls are turning into jobs.",
    icon: "PhoneCall",
  },
];

export const CONTACT_EMAIL = "hello@lightspeedroihq.com";
export const CONTACT_PHONE = "832-280-5553";
export const CONTACT_PHONE_HREF = "tel:+18322805553";
